export default "__VITE_ASSET__CUYCrEP3__"